import { __extends, __read, __spreadArray } from "tslib";
import { EventEmitter } from 'events';
export var ActionExecutorErrorCodes;
(function (ActionExecutorErrorCodes) {
    ActionExecutorErrorCodes["actionExecutionFailed"] = "ACTION_EXECUTION_FAILED";
    ActionExecutorErrorCodes["actionExecutionUnsupported"] = "ACTION_EXECUTION_UNSUPPORTED";
    ActionExecutorErrorCodes["actionExecutionErrorCode"] = "ACTION_EXECUTION_ERROR_CODE";
    /**
     * While the action failed, but we should proceed as if it succeeded.
     */
    ActionExecutorErrorCodes["actionExecutionFailSilently"] = "ACTION_EXECUTION_FAIL_SILENTLY";
    ActionExecutorErrorCodes["actionDoNotExecuteNext"] = "ACTION_DO_NOT_EXECUTE_NEXT";
    ActionExecutorErrorCodes["invalidActionType"] = "INVALID_ACTION_TYPE";
    ActionExecutorErrorCodes["invalidAppTarget"] = "INVALID_APP_TARGET";
    ActionExecutorErrorCodes["invalidOpenExternalTarget"] = "INVALID_OPEN_EXTERNAL_TARGET";
    ActionExecutorErrorCodes["invalidPayloadArguments"] = "INVALID_PAYLOAD_ARGUMENTS";
    ActionExecutorErrorCodes["unknown"] = "UNKNOWN";
})(ActionExecutorErrorCodes || (ActionExecutorErrorCodes = {}));
export var ActionExecutorErrorMessages;
(function (ActionExecutorErrorMessages) {
    ActionExecutorErrorMessages["contentLaunchingFailed"] = "Content launching failed";
    ActionExecutorErrorMessages["deepLinkToApp"] = "Unable to deep link to app";
    ActionExecutorErrorMessages["deletingInLoop"] = "Deleting file in loop";
    ActionExecutorErrorMessages["deletingInSharepoint"] = "Deleting file in sharepoint";
    ActionExecutorErrorMessages["downloadConvertContentFailed"] = "Unable to download and convert content";
    ActionExecutorErrorMessages["notImplemented"] = "Action executor has not yet been implemented";
    ActionExecutorErrorMessages["openExternal"] = "Unable to execute action to open in new browser";
    ActionExecutorErrorMessages["payloadMissing"] = "Payload is missing from action executor";
    ActionExecutorErrorMessages["payloadInvalid"] = "Unexpected payload type in action executor";
    ActionExecutorErrorMessages["unableToFindAnActionHandlerForType"] = "Unable to find an action execution handler for requested type";
    ActionExecutorErrorMessages["unableToConvertDownload"] = "Unable to convert & download content";
    ActionExecutorErrorMessages["unableToShare"] = "Unable to share content";
    ActionExecutorErrorMessages["unableToDelete"] = "Unable to delete content";
    ActionExecutorErrorMessages["unableToRestoreUndefined"] = "Restoration returned undefined value";
    ActionExecutorErrorMessages["unableToRemoveDeletedFileFromCache"] = "Unable to remove deleted file from cache";
    ActionExecutorErrorMessages["unknownErrorOccurred"] = "An unknown error occurred";
})(ActionExecutorErrorMessages || (ActionExecutorErrorMessages = {}));
export var ActionExecutorEventType;
(function (ActionExecutorEventType) {
    ActionExecutorEventType["RunNext"] = "run-next";
})(ActionExecutorEventType || (ActionExecutorEventType = {}));
var ActionExecutorEventEmitter = /** @class */ (function (_super) {
    __extends(ActionExecutorEventEmitter, _super);
    function ActionExecutorEventEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionExecutorEventEmitter.prototype.on = function (event, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listener) {
        return _super.prototype.on.call(this, event, listener);
    };
    ActionExecutorEventEmitter.prototype.once = function (event, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listener) {
        return _super.prototype.once.call(this, event, listener);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ActionExecutorEventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return _super.prototype.emit.apply(this, __spreadArray([event], __read(args), false));
    };
    return ActionExecutorEventEmitter;
}(EventEmitter));
export { ActionExecutorEventEmitter };
//# sourceMappingURL=actionExecutor.js.map